<nz-card nzTitle="Processing history document" [nzExtra]="headerExtra">
  <nz-result
    *ngIf="error$ | async as errorMsg; else resultTpl"
    [nzIcon]="'meh-twotone'"
    nzTitle="An error occurred"
    [nzSubTitle]="errorMsg"
  ></nz-result>

  <ng-template #headerExtra>
    <a target="_blank" rel="external" [href]="siteUrl">
      <i nz-icon nzType="link"></i>
      SharePoint site
    </a>
  </ng-template>
</nz-card>

<ng-template #resultTpl>
  <nz-skeleton [nzActive]="true" [nzLoading]="(isDesignLoading$ | async) ?? false">
    <nz-table
      #phdTable
      [nzData]="(processingHistoryDocuments$ | async) ?? []"
      [nzLoading]="(isLoading$ | async) ?? false"
      nzSize="small"
      [nzFrontPagination]="false"
    >
      <thead>
        <tr>
          <th>Name</th>
          <th>Status</th>
          <th>Element number</th>
          <th>Element name</th>
          <th>Theme</th>
        </tr>
      </thead>
      <tbody class="em-no-table-row-hover">
        <tr *ngFor="let phd of phdTable.data; trackBy: trackByRef">
          <td>
            <a target="_blank" rel="external" [href]="phd.webUrl">
              {{ phd.name }}
            </a>
          </td>
          <td>{{ phd.status }}</td>
          <td>{{ phd.elementNumber }}</td>
          <td>{{ phd.elementName }}</td>
          <td>{{ phd.theme }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-skeleton>
</ng-template>
